module.exports = {

    resources: {
        site: {
            name: 'Site |||| Sites',
            fields: {
                id: 'id',
                shift: 'shift',
                operatorId: 'operatorId',
                firstName: 'First Name',
                lastName: 'Last Name'
            },
            form: {
                edit: {
                    idHint: 'Unique identifier',
                }
            },
            inputs : {
            }
        }
    }
}
